<div class="p-2 pb-14 flex-1 h-full  overflow-y-auto">
    <div class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="vehicleForm" (ngSubmit)="onSave()">
        <div>
            <h1 class="heading">
                {{vehicleId ? 'Edit' : 'Add'}}
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <h2 class="heading">
                Vehicle Details
            </h2>
            <p class="text-sm-light">
                Please provide the following information about vehicle
            </p>
        </div>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">

            <!-- description -->
            <div class="space-y-1">
                <label class="subheading">
                    Name <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="description" type="text" [readOnly]="verification.isDescription" [ngClass]="verification.isDescription ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>

                <div *ngIf="submitted && form.description.errors">
                    <div *ngIf="form.description.errors.required" class="pt-1 text-red-600 text-xs">
                        Name is required
                    </div>
                </div>
            </div>

            <!-- vin -->
            <div class="space-y-1">
                <label class="subheading">
                    VIN <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="vin" type="text" [readOnly]="verification.isVin" [ngClass]="verification.isVin ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>


                <div *ngIf="submitted && form.vin.errors">
                    <div *ngIf="form.vin.errors.required" class="pt-1 text-red-600 text-xs">
                        VIN is required
                    </div>
                </div>
            </div>

            <!-- licensePlateNumber -->
            <div class="space-y-1">
                <label class="subheading">
                    License Plate Number <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="licensePlateNumber" type="text" value="New York"  [readOnly]="verification.isVin" [ngClass]="verification.isVin ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>

                <div *ngIf="submitted && form.licensePlateNumber.errors">
                    <div *ngIf="form.licensePlateNumber.errors.required" class="pt-1 text-red-600 text-xs">
                        License Plate Number is required
                    </div>
                </div>
            </div>

            <!-- year -->
            <div class="space-y-1">
                <label class="subheading">
                    Year <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="year" type="number" [readOnly]="verification.isYear" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                         [ngClass]="verification.isYear ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>

                <div *ngIf="submitted && form.year.errors">
                    <div *ngIf="form.year.errors.required" class="pt-1 text-red-600 text-xs">
                        Year is required
                    </div>
                </div>
            </div>

            <!-- make -->
            <div class="space-y-1">
                <label class="subheading">
                    Make <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="make" type="text" [readOnly]="verification.isMake" [ngClass]="verification.isMake ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>

                <div *ngIf="submitted && form.make.errors">
                    <div *ngIf="form.make.errors.required" class="pt-1 text-red-600 text-xs">
                        Make is required
                    </div>
                </div>
            </div>

            <!-- model -->
            <div class="space-y-1">
                <label class="subheading">
                    Model <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="model" type="text" [readOnly]="verification.isModel" [ngClass]="verification.isModel ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>

                <div *ngIf="submitted && form.make.errors">
                    <div *ngIf="form.make.errors.required" class="pt-1 text-red-600 text-xs">
                        Model is required
                    </div>
                </div>
            </div>

            <!-- color -->
            <div class="space-y-1">
                <label class="subheading">
                    Color <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="color" type="text" [readOnly]="verification.isColor" [ngClass]="verification.isColor ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>
                <div *ngIf="submitted && form.color.errors">
                    <div *ngIf="form.color.errors.required" class="pt-1 text-red-600 text-xs">
                        Color is required
                    </div>
                </div>
            </div>


            <!-- <div class="space-y-1">
                <label class="subheading">
                    Vehicle Type
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="type" type="text" value="zain.qa@yamsol.com" readonly />
                    </div>
                </div>

                <div *ngIf="submitted && form.type.errors">
                    <div *ngIf="form.type.errors.required" class="pt-1 text-red-600 text-xs">
                        Vehicle Type is required
                    </div>
                </div>
            </div> -->


            <ng-container formGroupName="garageAddress">

                <!-- Garaged address name -->
                <div class="space-y-1">
                    <label class="subheading">
                        Garage  Address <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                             <!-- Input with googlePlace directive -->
                        <input *ngIf="!verification.garageAddress?.isName" googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeGarageOriginAddress()"
                        formControlName="name" type="text" [disabled]="verification.garageAddress?.isName"
                        [readOnly]="verification.garageAddress?.isName"
                        [ngClass]="verification.garageAddress?.isName ? '' : 'border-red-600 dark:border-red-600'"
                        placeholder="Enter the address" />

                    <!-- Input without googlePlace directive -->
                    <input *ngIf="verification.garageAddress?.isName" (onSelect)="onSelectAddress($event)"  (input)="onChangeGarageOriginAddress()" formControlName="name"
                        type="text" [disabled]="verification.garageAddress?.isName"
                        [readOnly]="verification.garageAddress?.isName"
                        [ngClass]="verification.garageAddress?.isName ? '' : 'border-red-600 dark:border-red-600'"
                        placeholder="Enter the address" />
                        </div>
                    </div>

                    <div *ngIf="submitted">
                        <div *ngIf="garageAddressForm.get('name')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Garage Address is required
                        </div>
                        <p *ngIf="garageAddressForm?.errors?.invalidAddress" class="mt-2 text-red-600 text-xs">
                              Invalid address (select from the dropdown)
                            </p>
                    </div>
                </div>

                <!-- city -->
                <div class="space-y-1">
                    <label class="subheading">
                        City <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="city" type="text" [readOnly]="verification.garageAddress?.isCity" [ngClass]="verification.garageAddress?.isCity ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>

                    <div *ngIf="submitted && garageAddressForm.get('city')?.errors">
                        <div *ngIf="garageAddressForm.get('city')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            City is required
                        </div>
                    </div>
                </div>

                <!-- state -->
                <div class="space-y-1">
                    <label class="subheading">
                        State <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="state" type="text" [readOnly]="verification.garageAddress?.isState" [ngClass]="verification.garageAddress?.isState ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>

                    <div *ngIf="submitted && garageAddressForm.get('state')?.errors">
                        <div *ngIf="garageAddressForm.get('state')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            State is required
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- serviceAreas -->
            <div class="space-y-1">
                <label class="subheading">
                    Service Area(s)
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="serviceAreas" type="text" [readOnly]="verification.isServiceAreas" [ngClass]="verification.isServiceAreas ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>

                <div *ngIf="submitted && form.serviceAreas.errors">
                    <div *ngIf="form.serviceAreas.errors.required" class="pt-1 text-red-600 text-xs">
                        Service Areas are required
                    </div>
                </div>
            </div>

            <div class="space-y-1">
                <label class="subheading">
                Space Type <span class="text-red-600">*</span>
                </label>
                <div>
                    <div>
                        <select formControlName="spaceType" [disabled]="verification.isSpaceType" [ngClass]="verification.isSpaceType 
                            ? 'bg-gray-100' 
                            : 'border-red-600 dark:border-red-600'">
                            <option [disabled]="verification.isSpaceType" value=""> Select Space Type</option>
                            <option *ngFor="let spaceType of spaceTypes" [disabled]="verification.isSpaceType"  value="{{spaceType.id}}">{{spaceType.title | uppercase}}</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.spaceType.errors">
                        <p *ngIf="form.spaceType.errors.required" class="pt-1 text-red-600 text-xs">
                            Space Type is required
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <div class="mt-4">
            <h2 class="heading">
                General Information
            </h2>
            <p class="text-sm-light">
                Please provide the following information.
            </p>
        </div>

        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">

            <ng-container formGroupName="images">

                <!-- registration -->
                <div class="space-y-1">
                    <label class="subheading">
                        Registration
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <!-- <input #registrationImage accept="image/*" type="file"
                                (change)="uploadRegistrationImage(registrationImage)" /> -->

                            <input #registrationImage type="file" accept="Image/*" [disabled]="verification.images?.isRegistration" [readonly]="verification.images?.isRegistration"  [ngClass]="verification.images?.isRegistration ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(registrationImage, imagesForm.get('registration'))" />

                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500" *ngIf="imagesForm.get('registration')?.value">
                                    <a target="_blank" [href]="imagesForm.get('registration')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(imagesForm.get('registration')?.value) }}
                                    </a>
                                </div>
                                <div class="flex justify-end gap-2" *ngIf="imagesForm.get('registration')?.value && !verification.images?.isRegistration">
                                    <button
                                        type="button"
                                        [appCopyToClipboard]="imagesForm.get('registration')?.value" copyLabel="document link" copyTooltip="Copy link"
                                        class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                        </svg>
                                    </button>
                                    <button
                                        (click)="deleteFile(imagesForm.get('registration'), registrationImage)"
                                        class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="submitted && imagesForm.get('registration')?.errors">
                        <div *ngIf="imagesForm.get('registration')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Registration is required
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','registration')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','registration') }}
                    </p>
                </div>
                </ng-container>
                <ng-container formGroupName="dates">
                    <div class="space-y-1">
                        <label class="subheading">
                            Registration Date
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1 datePicker">
                                <input type="text" name="time" id="time" formControlName="registrationDate"
                                    [readonly]="true"
                                    [ngClass]="verification.dates?.isRegistrationDate ? 'date-filled': 'date-empty'"
                                    [owlDateTime]="registrationDate" [owlDateTimeTrigger]="registrationDate"
                                    [max]="datesForm.get('registrationExpireDate')?.value" />
                                <owl-date-time [pickerType]="'calendar'" [disabled]="verification.dates?.isRegistrationDate"
                                    (afterPickerClosed)="onDateChange(datesForm.get('registrationDate'))" #registrationDate></owl-date-time>
                    
                            </div>
                        </div>
                        <p *ngIf="getRejectionReason('documents','registrationDate')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','registrationDate') }}
                        </p>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Registration Expiration Date
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1 datePicker">
                                <input type="text" name="time" id="time" formControlName="registrationExpireDate"
                                    [readonly]="true"
                                    [ngClass]="verification.dates?.isRegistrationExpireDate ? 'date-filled': 'date-empty'"
                                    [owlDateTime]="registrationExpireDate" [owlDateTimeTrigger]="registrationExpireDate" 
                                     [min]="datesForm.get('registrationDate')?.value"/>
                                <owl-date-time [pickerType]="'calendar'" [disabled]="verification.dates?.isRegistrationExpireDate"
                                    (afterPickerClosed)="onDateChange(datesForm.get('registrationExpireDate'))"
                                    #registrationExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && datesForm.get('registrationExpireDate')?.errors">
                                <p *ngIf="datesForm.get('registrationExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                                   Registration Expiration Date must be after Expiration Date
                                </p>
                            </div>
                        <p *ngIf="getRejectionReason('documents','registrationExpireDate')" class="text-sm text-primary mt-1">
                            {{ getRejectionReason('documents','registrationExpireDate') }}
                        </p>
                    </div>
                </ng-container>
                
                
            <ng-container formGroupName="images">
                <div class="space-y-1">
                    <label class="subheading">
                        Inspection Report
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <!-- <input #inspectionImage accept="image/*" type="file"
                                                (change)="uploadInspectionReportImage(inspectionImage)" /> -->
                
                            <input #inspectionReportImage type="file" accept="Image/*"
                                [disabled]="verification.images?.isInspectionReport"
                                [readonly]="verification.images?.isInspectionReport"
                                [ngClass]="verification.images?.isInspectionReport ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(inspectionReportImage, imagesForm.get('inspectionReport'))" />
                
                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500" *ngIf="imagesForm.get('inspectionReport')?.value">
                                    <a target="_blank" [href]="imagesForm.get('inspectionReport')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(imagesForm.get('inspectionReport')?.value) }}
                                    </a>
                                </div>
                                <div class="flex justify-end gap-2"
                                    *ngIf="imagesForm.get('inspectionReport')?.value && !verification.images?.isInspectionReport">
                                    <button
                                        type="button"
                                        [appCopyToClipboard]="imagesForm.get('inspectionReport')?.value" copyLabel="document link" copyTooltip="Copy link"
                                        class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                        </svg>
                                    </button>
                                    <button (click)="deleteFile(imagesForm.get('inspectionReport'), inspectionReportImage)"
                                        class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <!-- <div *ngIf="submitted && form.inspReport.errors">
                                    <div *ngIf="form.inspReport.errors.required" class="pt-1 text-red-600 text-xs">
                                        Insp Report is required
                                    </div>
                                </div> -->
                    <p *ngIf="getRejectionReason('documents','inspectionReport')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','inspectionReport') }}
                    </p>
                </div>
            </ng-container>
                <!-- Inspection Report image -->
               <ng-container formGroupName="dates">
                <div class="space-y-1">
                    <label class="subheading">
                        Inspection Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <input type="text" name="time" id="time" formControlName="inspectionDate"
                                [readonly]="true"
                                [ngClass]="verification.dates?.isInspectionDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="inspectionDate" [owlDateTimeTrigger]="inspectionDate"
                                [max]="datesForm.get('inspectionExpireDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.dates?.isInspectionDate"
                                (afterPickerClosed)="onDateChange(datesForm.get('inspectionDate'))" #inspectionDate></owl-date-time>
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','inspectionDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','inspectionDate') }}
                    </p>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Inspection Expiration Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <input type="text" name="time" id="time" formControlName="inspectionExpireDate"
                                [readonly]="true"
                                [ngClass]="verification.dates?.isInspectionExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="inspectionExpireDate" [owlDateTimeTrigger]="inspectionExpireDate" 
                                [min]="datesForm.get('inspectionDate')?.value"/>
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.dates?.isInspectionExpireDate"
                                (afterPickerClosed)="onDateChange(datesForm.get('inspectionExpireDate'))"
                                #inspectionExpireDate></owl-date-time>
                        </div>
                    </div>
                    <div *ngIf="submitted && datesForm.get('inspectionExpireDate')?.errors">
                        <p *ngIf="datesForm.get('inspectionExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                             Inspection Expiration Date must be after Inspection Date
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('documents','inspectionExpireDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','inspectionExpireDate') }}
                    </p>
                </div>
                </ng-container>

                <!-- vehicle Images -->

                <ng-container formGroupName="images">
                <!--Front -->
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Image Front
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input #vehicleImage type="file" accept="Image/*"  [disabled]="verification.images?.isVehicle" [readonly]="verification.images?.isVehicle" [ngClass]="verification.images?.isVehicle ?'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(vehicleImage, imagesForm.get('vehicle'))"  />

                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500" *ngIf="imagesForm.get('vehicle')?.value">
                                    <a target="_blank" [href]="imagesForm.get('vehicle')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(imagesForm.get('vehicle')?.value) }}
                                    </a>
                                </div>
                                <div class="flex justify-end gap-2" *ngIf="imagesForm.get('vehicle')?.value && !verification.images?.isVehicle">
                                    <button
                                        type="button"
                                        [appCopyToClipboard]="imagesForm.get('vehicle')?.value" copyLabel="document link" copyTooltip="Copy link"
                                        class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                        </svg>
                                    </button>
                                    <button
                                        (click)="deleteFile(imagesForm.get('vehicle'), vehicleImage)"
                                        class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="submitted && imagesForm.get('vehicle')?.errors">
                        <div *ngIf="imagesForm.get('vehicle')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Vehicle Image Front is required
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','vehicle')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','vehicle') }}
                    </p>
                </div>

                <!-- back -->
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Image Back
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input #vehicleImageBack type="file" accept="Image/*" [disabled]="verification.images?.isBack" [readonly]="verification.images?.isBack" [ngClass]="verification.images?.isBack ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(vehicleImageBack, imagesForm.get('back'))" />

                           <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500" *ngIf="imagesForm.get('vehicle')?.value">
                                <a target="_blank" [href]="imagesForm.get('back')?.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(imagesForm.get('back')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="imagesForm.get('back')?.value && !verification.images?.isBack">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="imagesForm.get('back')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(imagesForm.get('back'), vehicleImageBack)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                           </div>
                        </div>
                    </div>

                    <div *ngIf="submitted && imagesForm.get('vehicle')?.errors">
                        <div *ngIf="imagesForm.get('vehicle')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Vehicle Image Back is required
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','back')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','back') }}
                    </p>
                </div>

                <!-- left -->
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Image Left
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input #vehicleImageLeft type="file" accept="Image/*" [disabled]="verification.images?.isLeft" [readonly]="verification.images?.isLeft" [ngClass]="verification.images?.isLeft ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(vehicleImageLeft, imagesForm.get('left'))" />

                      <div class="flex justify-between items-center mt-1">
                        <div class="text-xs text-gray-500" *ngIf="imagesForm.get('left')?.value">
                            <a target="_blank" [href]="imagesForm.get('left')?.value"
                                class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                {{ getFileName(imagesForm.get('left')?.value) }}
                            </a>
                        </div>
                        <div class="flex justify-end gap-2" *ngIf="imagesForm.get('left')?.value && !verification.images?.isLeft">
                            <button
                                type="button"
                                [appCopyToClipboard]="imagesForm.get('left')?.value" copyLabel="document link" copyTooltip="Copy link"
                                class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                </svg>
                            </button>
                            <button
                                (click)="deleteFile(imagesForm.get('left'), vehicleImageLeft)"
                                class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd"></path>
                                </svg>
                            </button>
                        </div>
                      </div>
                        </div>
                    </div>

                    <div *ngIf="submitted && imagesForm.get('left')?.errors">
                        <div *ngIf="imagesForm.get('left')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Vehicle Image Left is required
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','left')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','left') }}
                    </p>
                </div>

                <!-- right -->
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Image Right
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input #vehicleImageRight type="file" accept="Image/*" [disabled]="verification.images?.isRight" [readonly]="verification.images?.isRight" [ngClass]="verification.images?.isRight ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(vehicleImageRight, imagesForm.get('right'))" />

                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500" *ngIf="imagesForm.get('right')?.value">
                                    <a target="_blank" [href]="imagesForm.get('right')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(imagesForm.get('right')?.value) }}
                                    </a>
                                </div>
                                <div class="flex justify-end gap-2" *ngIf="imagesForm.get('right')?.value && !verification.images?.isRight">
                                    <button
                                        type="button"
                                        [appCopyToClipboard]="imagesForm.get('right')?.value" copyLabel="document link" copyTooltip="Copy link"
                                        class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                        </svg>
                                    </button>
                                    <button
                                        (click)="deleteFile(imagesForm.get('right'), vehicleImageRight)"
                                        class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="submitted && imagesForm.get('right')?.errors">
                        <div *ngIf="imagesForm.get('right')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Vehicle Image Right is required
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('documents','right')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('documents','right') }}
                    </p>
                </div>


            </ng-container>

            <div class="space-y-1">
                <label class="subheading">
                    Status
                </label>
                <div>
                    <div>
                        <select formControlName="isActive" class="" >
                            <option value="{{true}}">Active</option>
                            <option value="{{false}}">Inactive</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.isActive.errors">
                        <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                            Status is required
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">
            <button *ngIf="vehicleId && getInvalidFields().length" type="button" class="btn btn-secondary" (click)="sendInvalidFields()">
                Request Review
            </button>
            <button class="btn btn-secondary">
                {{vehicleId ? 'Update' : 'Create'}}
            </button>
        </section>
    </form>
</div>
</div>